module.exports = __webpack_public_path__ + "1afd7ac00caaa60884d0a9f1a54e3984.svg";